export default requester => {
    return {
        /**
         * Gets the current user's organization
         *
         * @param {object} handle
         **/
        me () {
            return requester.get(`/social/organizations/me`);
        },

        /**
         * Updates the current user's organization
         *
         * @param {string} id
         * @param {object} payload
         **/
        update (id, payload = {}) {
            return requester.put(`/social/organizations/${id}`, payload);
        },

        /**
         * Creates a new organization
         *
         * @param {object} payload
         **/
        create (payload = {}) {
            return requester.post(`/social/organizations`, payload);
        }
    };
}
  